<stx-modal>
  <ng-container>
    <div class="dialog-title">{{ 'session.warning.title' | translate }}</div>
    <div class="dialog-message">{{ 'session.warning.message' | translate }}</div>
    <stx-action-buttons
      [primaryText]="'session.warning.continue' | translate"
      (primaryAction)="onExtend()"
      [secondaryText]="'session.warning.logout' | translate"
      (secondaryAction)="onLogout()"
    ></stx-action-buttons>
  </ng-container>
</stx-modal>
